import type { AuthPermissionUser } from '../../services/authPermissions';

const EDITING_PRESENCE_ROLES = ['ADMIN', 'OPERATIONS', 'ORDER_STAFF'];

export function canUseEditingPresence(
  user: AuthPermissionUser | null | undefined,
): boolean {
  return EDITING_PRESENCE_ROLES.includes(user?.role || '');
}
